<template>
  <div class="szkf-wrap">
    <div class="szkf-top">
      <!-- <div class="szkf-top-left" v-if="false"></div> -->
      <div class="szkf-top-left">
        <div>
          <span class="selspan">优惠券号：</span>
          <input
            style="width: 115px; font-size: 14px"
            v-model="serach.couponcode"
            type="text"
            placeholder="券号"
          />
        </div>
        <div>
          <span class="selspan">优惠券名：</span>
          <div class="option">
            <select v-model="serach.couponid">
              <option value>全部</option>
              <option
                v-for="(item, index) in youhuilist"
                :key="index"
                :value="item.id"
              >{{ item.name }}</option>
            </select>
          </div>
        </div>
        <div>
          <span class="selspan">使用方式：</span>
          <div class="option">
            <select name v-model="serach.usetype">
              <option value>全部</option>
              <option value="0">线上预定</option>
              <option value="1">到店使用</option>
            </select>
          </div>
        </div>
        <div>
          <span class="selspan">使用状态：</span>
          <div class="option">
            <select name v-model="serach.usestatus">
              <option value>全部</option>
              <option value="0">未使用</option>
              <option value="1">已使用</option>
              <option value="2">禁止使用</option>
            </select>
          </div>
        </div>
        <!-- <div class="time-wrap">
          <span style="min-width: 4em">有效期：</span>
          <div class="block">
            <el-date-picker
              v-model="validity"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </div>-->
        <div class="diandian" @click="sermore">
          <span>更多</span>
        </div>
        <div class="submitchecked" @click="doserach()">搜索</div>
      </div>
      <div class="yhq-buttom" v-if="ckIndex > -1">
        <div v-if="jinyong" :class="{ yhqchecked: yhqOperaton == 1 }" @click="jinyongIt">禁用</div>
        <div v-if="qiyong" :class="{ yhqchecked: yhqOperaton == 2 }" @click="qiyongIt">启用</div>
      </div>
    </div>

    <div class="szkf-container">
      <img src="../assets/image/lq-bg.png" alt />
      <div>
        <div class="yx-wrap">
          <div class="yx-title">
            <!-- <div class="xuhao">ID</div> -->
            <div>券号</div>
            <div>优惠券名称</div>
            <div>有效期</div>
            <div>使用方式</div>
            <div>金额</div>
            <div>领取人</div>
            <div>领取时间</div>
            <div>使用时间</div>
            <div>状态</div>
          </div>
          <div class="yx-contaniner">
            <transition-group name="list" tag="p">
              <div
                :class="['yx-item-hy', { ckcheck: ckIndex == index }]"
                v-for="(item, index) in dataList"
                :key="index"
                @click="chooseIndex(index, item)"
                @dblclick="dblItem(index)"
              >
                <div>{{ item.couponcode }}</div>
                <div>{{ item.name }}</div>
                <div
                  :title="
                    item.validitybegintime + ' 至 ' + item.validityendtime
                  "
                >{{ item.validityendtime }}</div>
                <div v-if="item.usetype == 0">线上预定</div>
                <div v-else-if="item.usetype == 1">到店使用</div>
                <div>{{ item.rate }}元</div>
                <div>{{ item.nickname }}</div>
                <div>{{ item.receivetime }}</div>
                <div :title="item.usetime">{{ item.usetime }}</div>
                <div v-if="item.usestatus == 0">未使用</div>
                <div v-else-if="item.usestatus == 1">已使用</div>
                <div v-else-if="item.usestatus == 2">禁止使用</div>
                <div v-else></div>
              </div>
            </transition-group>
            <div class="footer">
              <div class="page-bar" v-if="length == 0">无数据</div>
              <div class="page-bar" v-else>
                <a v-if="serach.offset !== 1" class="banclick" @click="changePage('up')">«</a>
                <a
                  v-for="(item,index) in pages"
                  :class="{ active: serach.offset == item.pnum }"
                  :key="index"
                  v-show="item.show"
                  @click="changePage(item.pnum)"
                >{{ item.pval }}</a>
                <a v-if="serach.offset != totalPage" @click="changePage('next')">»</a>
                <b style="margin-left: 5em">
                  共
                  <i>{{ serach.offset }} / {{ totalPage }}</i>页
                </b>
                <b style="margin-left: 1em">
                  共
                  <i>{{ maxcount }}</i>条
                </b>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <transition name="bkgl2" v-if="vssermore">
      <div class="bkgl2-wrap">
        <div class="bkgl2-inner" style="width: 730px">
          <div class="bkgl2-header">
            <span>优惠券查找</span>
            <img src="../assets/image/close.png" alt @click="serclose()" />
          </div>
          <div class="bkgl2-container">
            <div class="bkgl2-datas">
              <div class="bkgl2-item">
                <div>
                  <span>优惠券号码</span>
                   <input
                   class="serinp"
                    v-model="serach.couponcode"
                    type="text"
                    placeholder="券号"
                  />
                </div>

                <div>
                  <span>优惠券名成</span>
                  <select  class="serinp" v-model="serach.couponid">
                  <option value>全部</option>
                  <option
                    v-for="(item, index) in youhuilist"
                    :key="index"
                    :value="item.id"
                  >{{ item.name }}</option>
                </select>
                </div>
               
              </div>
              <div class="bkgl2-item">
                 <div>
                  <span>使用方式</span>
                    <select  class="serinp" name v-model="serach.usetype">
                    <option value>全部</option>
                    <option value="0">线上预定</option>
                    <option value="1">到店使用</option>
                  </select>
                </div>
                <div>
                  <span>使用状态</span>
                  <select  class="serinp" name v-model="serach.usestatus">
                    <option value>全部</option>
                    <option value="0">未使用</option>
                    <option value="1">已使用</option>
                    <option value="2">禁止使用</option>
                  </select>
                </div>
               
              </div>

              <div class="bkgl2-item"  >
                <div >
                  <span>有效期开始</span>
                  <el-date-picker
                    v-model="use"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="有效期截止"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  ></el-date-picker>
                </div>
              </div>
              <div class="bkgl2-item">
                <div>
                  <span>领取时间开始</span>
                 <el-date-picker
                    v-model="receive"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="领取时间截止"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  ></el-date-picker>
                </div>
              </div>
            </div>
            <div class="bkgl2-button">
              <div @click="qingkong()">全部</div>
              <div @click="serclose()">取消</div>
              <div @click="sersubmit()">搜索</div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { getRequest, postRequest } from "@/api/api1.js";
import { CheckboxButton } from "element-ui";
function AsyncErrCatch(Promise) {
  return Promise.then(data => {
    return [null, data];
  }).catch(err => {
    return [err];
  });
}
export default {
  data() {
    return {
      dozhengc: false,
      dojiny: false,
      dozhux: false,
      dosuok: false,
      visible: false,
      status: "",
      // status: 0, //默认会员正常，如果为空的，改为正常
      dataList: [],
      length: "",
      //当前页码
      totalPage: 0, //总页码
      maxcount: 0,
      titleIndex: -1,
      ckIndex: -1,
      vcardstatus: false, //设置卡状态
      ckhuiyuan: [],
      ckstatus: -1,
      obj: {},
      serach: {
        limit: 10,
        offset: 1,
        usetype: "",
        usestatus: "",
        couponid: "",
        validitybegintime: "",
        validityendtime: "",
        receivetimestart: "",
        receivetimeend: "",
        usetimestart: "",
        usetimeend: ""
      },
      serach1: {
        limit: 10,
        offset: 1,
        usetype: "",
        usestatus: "",
        couponid: "",
        validitybegintime: "",
        validityendtime: "",
        receivetimestart: "",
        receivetimeend: "",
        usetimestart: "",
        usetimeend: ""
      },
      vssermore: false,
      youhuilist: [],
      validity: [],
      receive: [],
      use: [],
      pages: [],
      firsrmore: false,
      endmore: false
    };
  },
  computed: {
    // list() {
    //   
    //   return this.$store.state.kfszRights;
    // },
    jinyong() {
      return this.$store.state.jinyong;
    },
    qiyong() {
      return this.$store.state.qiyong;
    },
    yhqOperaton() {
      return this.$store.state.yhqOperaton;
    }
  },
  watch: {
    "this.$store.state.tCouponList": function() {
      this.youhuilist = this.$store.state.tCouponList;
      //你需要执行的代码
    }
  },
  created() {
    this.$store.state.yhqOperaton = -1;
    this.$store.state.tCouponList = [];
  },
  mounted() {
    this.checkPower(); //验证权限，有没有权限做这些事，如果有就继续，方法里面有权限的获取
    if (this.$store.state.tCoupon.length > 0) {
      //一整条数据是否存在
      this.youhuilist = this.$store.state.tCoupon; //list数组里面就是这一条数据的内容
    } else {
      let loadingInstance = this.$loading({ text: "加载中" }); //如果这数据不存在，则要去接口请求数据
      getRequest(
        "/tCoupon/selectAll?hotelId=" + localStorage.getItem("ihotelid")
      ).then(res => {
        this.$nextTick(() => {
          loadingInstance.close();
        }); //不回调
        if (res.status == 200) {
          this.youhuilist = res.data; //加载成功的话，这条数据就赋给list

          this.$store.state.tCoupon = res.data; //这一条数据已经显示在页面上了
        } else {
          this.$mymessage({
            content: res.message,
            type: "error",
            time: 3000,
            hasClose: true
          });
        }
      });
    }
    this.getData();
  },
  methods: {
    checkPower() {
      if (!this.power.checkedpower("0702000")) {
        this.$router.push("/power");
      }
      this.zhuangtai = this.power.checkedpower("0702001");
      // this.dojiny = this.power.checkedpower("08010002");
      // this.dozhux = this.power.checkedpower("08010002");
      // this.dosuok = this.power.checkedpower("08010002");
    },
    sersubmit(){
      this.doserach();
      this.vssermore = false;
      this.serclose();
    },
    qingkong(){
      this.serach =this.serach1;
      this.doserach();
    },
    
    serclose(){
      this.vssermore = false;
    },
    getData() {
      // if (this.$store.state.tCouponList.length > 0) {
      //   this.dataList = this.$store.state.tCouponList;
      // } else {
      let loadingInstance = this.$loading({ text: "优惠券加载中..." });
      postRequest("/tCouponList/selectCoupons", this.serach).then(res => {
        this.$nextTick(() => {
          loadingInstance.close();
        });
        if (res.status == 200) {
          this.dataList = res.data;
          this.$store.state.tCouponList = res.data;
          this.length = res.data.length;
          this.maxcount = res.count;
          this.getpage();
        } else {
          this.$mymessage({
            content: res.message,
            type: "error",
            time: 3000,
            hasClose: true
          });
        }
      });
      // }
    },
    doserach() {
      if (this.validity.length > 0) {
        this.serach.validitybegintime = this.validity[0];
        this.serach.validityendtime = this.validity[1];
      }
      if (this.receive.length > 0) {
        this.serach.receivetimestart = this.receive[0];
        this.serach.receivetimeend = this.receive[1];
      }
      if (this.use.length > 0) {
        this.serach.usetimestart = this.use[0];
        this.serach.usetimeend = this.use[1];
      }
      this.serach.offset = 1;
      this.vssermore = false;
      this.getData();
    },
    sermore() {
      this.vssermore = !this.vssermore;
    },
    getpage() {
      this.pages = [];
      this.totalPage = Math.ceil(this.maxcount / this.serach.limit);
      if (this.totalPage > 7) {
        let first = {};
        first.pnum = "upmore";
        first.pval = "...";

        if (this.serach.offset > 3) {
          this.firsrmore = true;
        } else {
          this.firsrmore = false;
        }
        first.show = this.firsrmore;
        this.pages.push(first);
      }

      for (var i = 1; i <= this.totalPage; i++) {
        let pagenum = {};
        pagenum.pnum = i;
        pagenum.pval = i;
        if (i == this.totalPage) {
          if (this.totalPage > 7) {
            let end = {};
            end.pnum = "downmore";
            end.pval = "...";
            if (this.serach.offset < this.totalPage - 2) {
              this.endmore = true;
            } else {
              this.endmore = false;
            }
            end.show = this.endmore;
            this.pages.push(end);
          }
          pagenum.show = true;
        } else {
          if (this.totalPage > 7) {
            if (
              i == this.serach.offset ||
              i == this.serach.offset - 1 ||
              i == this.serach.offset - 2 ||
              i == this.serach.offset + 1 ||
              i == this.serach.offset + 2
            ) {
              pagenum.show = true;
            } else {
              pagenum.show = false;
            }
          } else {
            pagenum.show = true;
          }
        }

        this.pages.push(pagenum);
        // this.getDate()
      }
    },
    changePage(page) {
      if (this.serach.offset > 0 && this.serach.offset <= this.pages.length) {
        if (page == "next") {
          this.serach.offset++;
        } else if (page == "up") {
          this.serach.offset--;
        } else if (page == "upmore") {
          if (this.serach.offset - 5 > 0) {
            this.serach.offset -= 5;
          } else {
            this.serach.offset = 1;
          }
        } else if (page == "downmore") {
          if (this.serach.offset + 5 < this.totalPage) {
            this.serach.offset += 5;
          } else {
            this.serach.offset = this.totalPage;
          }
        } else {
          this.serach.offset = page;
        }

        this.getpage();
        this.getData();
      }
    },
    ready: function() {},
    chooseIndex(index, item) {
      this.$store.state.jinyong = false;
      this.$store.state.qiyong = false;
      this.ckIndex = index;
      
      if (item.usestatus == 0) {
        this.$store.state.jinyong = true;
      } else if (item.usestatus == 2) {
        this.$store.state.qiyong = true;
      }
    },
    dblItem(index) {
      this.ckIndex = index;
      // this.operation(1);
    },
    condition(index) {
      if (index == 0 && this.ckIndex >= 0) {
        this.ckhuiyuan = this.dataList[this.ckIndex];
        this.ckstatus = this.dataList[this.ckIndex].status;
        this.vcardstatus = true;
        this.titleIndex = 0;
      } else {
        this.$mymessage({
          content: "请选择需要操作的会员",
          type: "error",
          time: 2000,
          hasClose: true
        });
      }
    },
    jinyongIt() {
      this.$store.state.yhqOperaton = 1;
      let obj = {
        title: "禁用",
        message: "您确定要禁用此优惠券吗？",
        youhuiquanIndex: this.ckIndex,
        couponcode: this.dataList[this.ckIndex].couponcode
      };
      this.$confirm({ obj });
    },
    qiyongIt() {
      this.$store.state.yhqOperaton = 2;
      let obj = {
        title: "启用",
        message: "您确定要启用此优惠券吗？",
        youhuiquanIndex2: this.ckIndex,
        couponcode: this.dataList[this.ckIndex].couponcode
      };
      this.$confirm({ obj });
    },
    changestatus(status) {
      this.ckstatus = status;
    },

    close() {
      this.vcardstatus = false;
      this.ckhuiyuan = [];
      this.titleIndex = -1;
    },
    confirm() {
      this.obj.status = this.ckstatus;
      this.obj.id = this.ckhuiyuan.id;
      postRequest("/tMember/updateTMember", this.obj).then(res => {
        if (res.status == 200) {
          //创建 添加 删除按钮设置没选中
          this.$mymessage({
            content: "设置成功",
            type: "success",
            time: 2000,
            hasClose: true
          });
          this.dataList[this.ckIndex].status = this.ckstatus;
          this.vcardstatus = false;
          this.ckstatus = -1;
          this.obj = {};
          this.titleIndex = -1;
        } else {
          this.$mymessage({
            content: res.message,
            type: "error",
            time: 2000,
            hasClose: true
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.yhq-buttom {
  width: 10%;
  height: 90%;
  position: absolute;
  right: 1%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  border-radius: 7px;
  font-size: 0.75em;
  box-shadow: 8px 8px 15px #b9ccec, -8px -8px 15px #ffffff;
}
.yhq-buttom > div {
  width: 6em;
  height: 2.4em;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background: #1471FE; */
  border-radius: 0.5em;
  color: #575f6b;
  margin: 0 1.5em;
  cursor: pointer;
}
.yhq-buttom .yhqchecked {
  color: #fb7a01;
  font-weight: 500;
  box-shadow: 4px 4px 8px #b9ccec inset, -4px -4px 8px #ffffff inset;
  font-size: 14px;
}
.yx-wrap {
  width: 100%;
  height: 100%;
  padding: 1%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.yx-title {
  width: 100%;
  display: flex;
  flex-shrink: 0;
}
.yx-title div {
  text-align: center;
  color: #2c3036;
  font-size: 0.8em;
  line-height: 3.2em;
  width: 13%;
}
.yx-title .xuhao {
  width: 5%;
}
.yx-title .name {
  width: 6%;
}
.yx-title .zhuangt {
  width: 8%;
}
.yx-title .shenfz {
  width: 23%;
}
.yx-title .cardno {
  width: 12%;
}
.yx-item-hy .xuhao {
  width: 5%;
}
.yx-item-hy .name {
  width: 6%;
}
.yx-item-hy .zhuangt {
  width: 8%;
}
.yx-item-hy .shenfz {
  width: 23%;
}
.yx-item-hy .cardno {
  width: 12%;
}
.yx-contaniner {
  color: #6d798e;
  font-size: 14px;
  flex: 1;
  overflow: hidden;
  position: relative;
}
.yx-contaniner .ckcheck {
  box-shadow: 3px 3px 4px #a0bdee inset, -3px -3px 4px white inset;
  border: 1px solid #1471fe;
  border-radius: 10px;
}
/* .yx-contaniner p{
  margin-bottom: 20px;
} */

.yx-item-hy {
  display: flex;
  width: 100%;
  border: 1px solid #e7f0ff;
  cursor: pointer;
}
.yx-item-hy div {
  text-align: center;
  line-height: 3em;
  width: 13%;
  overflow: hidden;
  white-space: nowrap;
}

.yx-checked {
  box-shadow: 3px 3px 4px #a0bdee inset, -3px -3px 4px white inset;
  border: 1px solid #1471fe;
  border-radius: 10px;
}

.list-enter-active,
.list-leave-active {
  transition: all 1s;
}
.list-enter
/* .list-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(100%);
}
.list-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.szkf-wrap {
  width: 100%;
  height: 100%;
  margin-left: -1%;
  z-index: 99;
  position: relative;
  overflow: hidden;
}
input {
  outline: none;
  box-shadow: 2px 2px 4px #b1c9f1 inset, -2px -2px 4px #ffffff inset;
  border-radius: 3px;
  padding-left: 8px;
  color: #6d798e;
  height: 28px;
  line-height: 28px;
  width: 57%;
}
::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #9ca4b3;
}

::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #9ca4b3;
}

:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #9ca4b3;
}
/* .szkf-top-left input{
  padding: 0 4px;
} */
.szkf-top {
  width: 100%;
  height: 7%;
  padding: 0 1% 0 3%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2%;
  position: relative;
}
.szkf-top-left {
  width: 880px;
  height: 90%;
  box-shadow: 8px 8px 20px #b9ccec, -8px -8px 15px #ffffff;
  border-radius: 7px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: #575f6b;
  position: absolute;
  font-size: 14px;
  padding-left: 10px;
}
.szkf-top-left div {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  /* padding: 0 0.5%;
  margin: 0 auto; */
  cursor: pointer;
}
.selspan {
  width: 70px;
}

div.submitchecked {
 margin:0px 10px;
    width: 50px;
    height: 28px;
    border-radius: 6px;
    background: #1471fe;
    color: #ffffff;
    font-size: 14px;
    text-align: center;
    box-shadow: 8px 8px 20px #b9ccec, -8px -8px 15px #ffffff;
}
div.diandian {
     width: 50px;
    height: 28px;
    border-radius: 6px;
    background: #1471fe;
    color: #ffffff;
    font-size: 14px;
    text-align: center;
    box-shadow: 8px 8px 20px #b9ccec, -8px -8px 15px #ffffff;
}
div.submitchecked:hover{
  transform: scale(1.1);
}
div.diandian:hover{
  transform: scale(1.1);
}
div.otherss {
  display: none;
}
div.diandian:visited > div.otherss {
  display: block;
  width: 500px;
  height: 400px;
  transition: width 2s;
  -webkit-transition: width 2s;
  background: #b9ccec;
  box-shadow: 8px 8px 20px #b9ccec, -8px -8x 15px #fff;
  border-radius: 6px;
}
.szkf-top-right {
  /* width: 20%; */
  height: 90%;
  box-shadow: 8px 8px 20px #b9ccec, -8px -8px 15px #ffffff;
  border-radius: 7px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 0.8em;
  color: #575f6b;
  padding: 0 1.5%;
  position: absolute;
  right: 3%;
}
.szkf-top-right div {
  /* width: 30%; */
  height: 60%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
}
.titleChecked {
  background: url(../assets/image/lq-bg2.png);
  color: #fb7a01;
  background-size: 100% 100%;
  font-weight: bolder;
}

.szkf-top-right > div {
  cursor: pointer;
}
.szkf-container {
  width: 101.8%;
  height: 93%;
  margin: 0 0 0;
  position: absolute;
  top: 8.5%;
}
.szkf-container img {
  width: 100%;
  height: 100%;
  position: absolute;
}
.szkf-container > div {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  padding: 2% 3%;
  overflow: hidden;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 1s;
}
.fade-enter {
  transform: translateX(100%);
  opacity: 0;
}
.fade-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}
.list-enter-active,
.list-leave-active {
  transition: all 1s;
}
.list-enter
/* .list-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(100%);
}
.list-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}
/* 分页 */
.footer {
  width: 100%;
  align-items: center;
  cursor: pointer;
  position: absolute;
  bottom: 0;
}
.page-bar {
  width: 100%;
  height: 3em;
  text-align: center;
}

.active {
  background-color: #1471fe;
  color: #fff;
  border-radius: 100%;
}
a {
  border: 0px solid #ddd;
  text-decoration: none;
  position: relative;
  cursor: pointer;
  width: 2em;
  height: 2em;
  display: inline-block;
  line-height: 2em;
  margin: 0 0.2em;
  font-size: 1em;
  font-weight: bold;
  text-align: center;
}
.page-bar a:hover {
  background-color: #1471fe;
  color: #fff;
  border-radius: 100%;
}
.page-bar a.banclick {
  cursor: not-allowed;
}
.page-bar .active a {
  color: #fff;
  cursor: default;
  color: #428eff;
  /* background-color: #1471fe;
  border-color: #1471fe; */
}
.page-bar i {
  font-style: normal;
  color: #428eff;
  margin: 0px 4px;
  font-size: 12px;
}

.confirm-wrap {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.confirm-wrap::after {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgb(161, 160, 160);
  opacity: 0.4;
  content: "";
  z-index: -1;
}
.confirm-inner {
  width: 500px;
  border-radius: 10px;
  overflow: hidden;
  background: #e8f0ff;
}
.confirm-header {
  width: 100%;
  height: 50px;
  padding: 0 8px 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #2c3036;
}
.confirm-header img:hover {
  transform: scale(1.2);
  cursor: pointer;
}
.confirm-container {
  box-shadow: 0px 2px 4px #b9ccec inset;
  padding: 20px;
}
.confirm-message {
  height: 55px;
  font-size: 16px;
  color: #2c3036;
  margin-left: 20px;
  display: flex;
  justify-content: space-between;
}
.confirm-message div {
  width: 5em;
  height: 2em;
  line-height: 2em;
  text-align: center;
  color: #2c3036;
  box-shadow: 3px 3px 6px #a0bdee, -3px -3px 6px white;
  border-radius: 5px;
  cursor: pointer;
  background: #1471fe;
  color: #fff;
}
.statusactive {
  box-shadow: 3px 3px 4px #a0bdee inset, -3px -3px 4px white inset !important;
  border: 0;
  background: #e7f0ff !important;

  color: #2c3036 !important;
}
.confirm-message1 {
  height: 40px;
  font-size: 12px;
  color: red;
  margin-left: 20px;
}

.confirm-button {
  width: 100%;
  font-size: 10px;
  color: #575f6b;
  display: flex;
  justify-content: center;
}
.confirm-button div:nth-child(1) {
  margin-right: 20px;
}

.confirm-button div {
  width: 120px;
  height: 30px;
  box-shadow: 4px 0px 10px #b9ccec, -4px -4px 10px #ffffff;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #1471fe;
  color: white;
  cursor: pointer;
}
.confirm-enter-active,
.confirm-leave-active {
  transition: all 1s;
}
.confirm-enter {
  opacity: 0;
}
.confirm-leave-to {
  opacity: 0;
}

.serach-more {
  width: 80%;
  height: 5em;
  box-shadow: 3px 3px 4px #a0bdee inset, -3px -3px 4px white inset;
  justify-content: space-around;
  align-items: center;
  color: #575f6b;
  padding: 0 0.5%;
  position: absolute;
  left: 3%;
  z-index: 999;
  background: #e7f0ff;
  top: 12%;
  border-bottom-left-radius: 0.5em;
  border-bottom-right-radius: 0.5em;
  padding: 0.5% 1%;
}
.serach-div {
  display: flex;
}
.serach-div > div {
  width: 43%;
  display: flex;
  height: 2em;
  align-items: center;
  font-size: 0.8em;
  color: #575f6b;
  margin: 0.5% 0%;
}
.serach-div > span {
  width: 20%;
  text-align: right;
  margin-right: 8px;
  font-size: 10px;
  color: #575f6b;
  flex-shrink: 0;
}

.time-wrap {
  background: #e7f0ff;
  margin-left: 2.3% !important;
}
.sermargin {
  margin-left: 1%;
}
.szkf-top-left .block {
  width: 80%;
}
.el-date-editor {
  width: 100%;
}
.block {
  width: 12em;
}
.block .el-date-editor {
  width: 100%;
  background: #e7f0ff !important;
  border: 0;
}
.el-date-editor /deep/ .el-range-input {
  width: 170px !important;
  margin-right: 0px !important;
  height: 28px;
  line-height: 28px;
}
.el-date-editor /deep/ .el-range-separator {
  margin: 0 !important;
    /* margin-right: 32px !important;
    margin-left: 32px !important; */
    height: 28px;
    line-height: 28px;
    font-size: 14px;
    display: inline-block;
    width:110px;
}
.option select {
  color: #6d798e;
  font-size: 10px;
  /* border-radius: 3px; */
  /*清除select的边框样式*/
  border: none;
  /*清除select聚焦时候的边框颜色*/
  outline: none;
  /*将select的宽高等于div的宽高*/
  width: 100px;
  height: 28px;
  line-height: 28px;
  border: 1px solid #76a8f5;
  outline: none;
  border-radius: 3px;
  box-shadow: 2px 2px 4px #b1c9f1 inset, -2px -2px 4px #ffffff inset;
  /*隐藏select的下拉图标*/
  /* appearance: none; */
  /* -webkit-appearance: none; */
  /* -moz-appearance: none; */
  /*通过padding-left的值让文字居中*/
  padding-left: 8px;
  cursor: pointer;
  font-size: 14px;
}


.bkgl2-wrap {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
}
.bkgl2-wrap::after {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgb(161, 160, 160);
  opacity: 0.4;
  content: "";
  z-index: -1;
}
.bkgl2-inner {
  width: 450px;
  border-radius: 10px;
  overflow: hidden;
  background: #e8f0ff;
}
.bkgl2-header {
  width: 100%;
  height: 50px;
  padding: 0 8px 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  color: #2c3036;
}
.bkgl2-header img {
  cursor: pointer;
}
.bkgl2-header img:hover {
  transform: scale(1.2);
}
.bkgl2-container {
  box-shadow: 4px 4px 10px #b9ccec inset, -4px -4px 10px #ffffff inset;
  padding: 20px;
}
.bkgl2-datas {
  margin-bottom: 20px;
  box-shadow: 4px 4px 10px #b9ccec, -4px -4px 10px #ffffff;
  padding: 5px 10px 10px;
  border-radius: 10px;
}
.bkgl2-item {
  height: 40px;
  font-size: 10px;
  color: #575f6b;
}
.bkgl1-item {
  margin-bottom: 15px;
  height: 35px;
  font-size: 14px;
  color: #575f6b;
}
input {
  border: 1px solid #76a8f5;
  outline: none;
  box-shadow: 2px 2px 4px #b1c9f1 inset, -2px -2px 4px #ffffff inset;
  height: 28px;
  border-radius: 3px !important;
  padding-left: 8px;
  color: #6d798e;
  cursor: pointer;
  font-size:14px;
  width:170px;
}
.bkgl2-item {
  display: flex;
  align-items: center;
}
.bkgl2-item div {
  
  display: flex;
  align-items: center;
}
.bkgl1-item div {
  width: 100%;
  display: flex;
  align-items: center;
}
.bkgl1-item div span {
  width: 70px;
  flex-shrink: 0;
  margin-right: 10px;
  text-align: right;
}
.bkgl1-item div textarea {
  height: 36px;
  width: 690px;
}
.bkgl2-item div span {
  width: 100px;
  flex-shrink: 0;
  margin-right: 10px;
  text-align: right;
  font-size: 14px;
}
.bkgl2-item div input {
  width: 170px;
  height: 28px;
  font-size: 14px;
}
.bkgl2-item div .option select {
  width: 170px;
  font-size: 14px;
}
.option:after {
  background: none !important;
}
.bkgl2-message {
  font-size: 16px;
  margin-bottom: 15px;
  color: #333;
}
.bkgl2-button {
  width: 100%;
  font-size: 14px;
  color: #575f6b;
  display: flex;
  justify-content: center;
}
.bkgl20-button {
  width: 100%;
  font-size: 14px;
  color: #575f6b;
  display: flex;
  justify-content: space-between;
}

.bkgl2-button div:nth-child(1) {
  margin-right: 20px;
}
.bkgl2-button div:nth-child(2) {
  margin-right: 20px;
}
.bkgl20-button > div {
  display: flex;
}
.bkgl20-button > div div:hover {
  transform: scale(1.1);
}
.bkgl20-button > div div:nth-child(1) {
  margin-right: 10px;
}
.bkgl2-button div,
.bkgl20-button > div div {
  width: 120px;
  height: 30px;
  box-shadow: 4px 4px 10px #b9ccec, -4px -4px 10px #ffffff;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #1471fe;
  color: white;
  cursor: pointer;
}
.bkgl2-button div:hover {
  transform: scale(1.1);
}
.bkgl2-button2 {
  display: flex;
  justify-content: space-between;
}
.serinp{
     color: #6d798e;
    font-size: 10px;
    /* border-radius: 3px; */
    border: none;
    outline: none;
    width: 170px;
    height: 28px;
    line-height: 28px;
    border: 1px solid #76a8f5;
    outline: none;
    border-radius: 3px;
    box-shadow: 2px 2px 4px #b1c9f1 inset, -2px -2px 4px #ffffff inset;
    /* appearance: none; */
    /* -webkit-appearance: none; */
    /* -moz-appearance: none; */
    padding-left: 8px;
    cursor: pointer;
    font-size: 14px;
}
</style>